import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormArray } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/services/API/api.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { CachingService } from 'src/app/services/cache/caching.service';
import JeepStaticData from 'src/assets/JSON/JeepStatic.json';

@Component({
  selector: 'app-insurance',
  templateUrl: './insurance.component.html',
  styleUrls: ['./insurance.component.scss'],
})
export class InsuranceComponent implements OnInit {
  stateList: any = [];
  cityList: any = [];
  stateId: any = '';
  cityId: any = '';

  qtnResponseData: any = [];
  uniquePlans: any = [];
  chooseAddonsPlans: any = [];
  currentConfiguration: any;
  zeroDep = {
    PACKAGEID: 0,
  }; //for basic plan

  packageId: any = [];
  packageNameArr: any = [];
  packageAddons: any = [];
  packageAddonsAmount: any;

  premiumAmount: any;
  insuranceCost: any;

  modelSelected: any;
  modelName: any;
  variantDetails: any;
  insuranceDetails: any;
  enableAddSummary: boolean = false;

  insuranceProvider: any;
  insuranceProviderCode: any;
  quotationNumber: any;
  insuranceForm = new UntypedFormGroup({
    state: new UntypedFormControl('', Validators.required),
    city: new UntypedFormControl('', Validators.required),
    packageId: new UntypedFormControl('', Validators.required),
    chooseAddOnsId: new UntypedFormArray([]),
  });
  variants: any;

  constructor(
    private modalController: ModalController,
    private apiService: ApiService,
    public globalService: GlobalService,
    private cachingService: CachingService
  ) {}

  async ngOnInit() {
    this.currentConfiguration = await this.cachingService.getDataFromSession(
      'config'
    );
    this.modelSelected = await this.cachingService.getDataFromSession(
      'modelSelected'
    );
    this.variants = await this.cachingService.getDataFromSession(
      'variants'
    );
    
    this.variantDetails =
      this.currentConfiguration.selectedVariant.variant_name;
    this.modelName = this.modelSelected['model_name'];

    this.packageAddons = this.variants.insuranceAddons;
    this.insuranceCost = this.currentConfiguration.selectedVariant.insurance_cost;

    this.cityList = [];
    this.stateId = '';
    this.cityId = '';
    // this.getInsuranceDetails();

    // this.apiService
    //   .post('insurance/get-states', '')
    //   .then((res) => {
    //     if (res['msg'] == 'success') {
    //       this.stateList = res['response']['states'];
    //     } else {
    //       console.error('State Fetch Error Values Error ');
    //     }
    //   })
    //   .catch((err) => {
    //     console.error('State Values: ', err);
    //   });
  }

  onStateSelection(event: any) {
    let stateId = event.target.value;
    if (stateId != '') {
      this.stateId = stateId;
      let apiBody = {
        state_id: stateId.toString(),
      };
      let state = this.stateList.find(
        (el) => el.state_id == this.stateId
      ).state_name;

      this.apiService
        .post('insurance/get-cities', apiBody)
        .then((res) => {
          if (res['msg'] == 'success') {
            this.cityList = res['response']['cities'];
          } else {
            console.error('City Fetch Error Values Error ');
          }
        })
        .catch((err) => {
          console.error('City Values: ', err);
        });
    } else {
      this.cityList = [];
    }
  }

  onCitySelection(event: any): Promise<any> {
    return new Promise(async (resolve, reject) => {
      let cityId = event.target.value;
      if (cityId != '') {
        this.cityId = cityId;
        this.apiService
          .post('insurance/get-auth', '')
          .then(async (res) => {
            if (res['msg'] == 'success') {
              this.cachingService.setDataInSession(
                'authWrapperToken',
                res['response']['Token']
              );
              let result = await this.onGetQuotation();
              if (result) {
                resolve({
                  status: true,
                });
              }
            } else {
              console.error('Auth Wrapper Fetch Error Values Error ');
              reject({ status: false });
            }
          })
          .catch((err) => {
            console.error('Auth Wrapper Fetch Error: ', err);
            reject({ status: false });
          });
      } else {
        reject({ status: false });
      }
    });
  }

  async onGetQuotation(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      let apiBody = {
        Request_No: await this.cachingService.getDataFromSession('pin_no'),
        Single_IC_Qoute: 'Y',
        Dealer_Code: '',
        Variant_Code: this.currentConfiguration.colorSelected.variant_code,
        Exshowroom_Price:
          this.currentConfiguration.colorSelected.exshowroom_price,
        RTO_City: this.cityId,
        Vehicle_Type: 'P',
        Customer_State: this.stateId,
        Proposer_Type: 'I',
        token: await this.cachingService.getDataFromSession('authWrapperToken'),
      };
      this.apiService
        .post('insurance/get-quotation', apiBody)
        .then((res) => {
          if (res['msg'] == 'success') {
            if (
              res['response']['QuotationsList'][0]['Result_Message'] ==
              'Variant not exists.'
            ) {
              /**
               * Data from Json
               */
              this.qtnResponseData = JeepStaticData;
              this.uniquePlans = [];
              this.chooseAddonsPlans = [];
              this.qtnResponseData[0].ADD_ON_List.forEach((element) => {
                if (element.ADDONTYPE == 'PACKAGE')
                  this.uniquePlans.push(element);
              });
              this.qtnResponseData[0].ADD_ON_List.forEach((element) => {
                if (element.ADDONTYPE == 'STANDALONE')
                  this.chooseAddonsPlans.push(element);
              });
              this.quotationNumber = this.qtnResponseData[0].QuotationNo;
              this.premiumAmount = this.qtnResponseData[0].GROSS_Premium;
              this.insuranceProvider = this.qtnResponseData[0].ICName;
              this.insuranceProviderCode = this.qtnResponseData[0].ICCode;
            } else {
              /**
               * Data from API
               */
              this.qtnResponseData = res['response']['QuotationsList'][0];
              this.uniquePlans = [];
              this.chooseAddonsPlans = [];
              this.qtnResponseData.ADD_ON_List.forEach((element) => {
                if (element.ADDONTYPE == 'PACKAGE')
                  this.uniquePlans.push(element);
              });
              this.qtnResponseData[0].ADD_ON_List.forEach((element) => {
                if (element.ADDONTYPE == 'STANDALONE')
                  this.chooseAddonsPlans.push(element);
              });
              this.quotationNumber = this.qtnResponseData.QuotationNo;
              this.premiumAmount = this.qtnResponseData.GROSS_Premium;
              this.insuranceProvider = this.qtnResponseData.ICName;
              this.insuranceProviderCode = this.qtnResponseData.ICCode;
            }
            resolve({
              status: true,
            });
          } else {
            console.error('Get Qutation Fetch Error Values Error ');
            reject({ status: false });
          }
        })
        .catch((err) => {
          console.error('Get Qutation Fetch Error: ', err);
          reject({ status: false });
        });
    });
  }

  closeInsurance() {
    this.globalService.dismissModal();
  }

  onPackageSelection(itemPlan) {
    this.insuranceForm.patchValue({
      packageId: itemPlan.PACKAGEID,
    });
    this.packageId = [];
    this.packageNameArr = [];
    if (itemPlan.PACKAGEID != 0) {
      this.packageId.push(itemPlan.PACKAGEID);
      this.packageNameArr.push(itemPlan.PACKAGENAME);
      this.packageAddonsAmount = itemPlan.ADDON_PREM_TOTAL;
      this.packageAddons = itemPlan.ADDONNAME.split(',');

      if (Number(this.premiumAmount) && Number(this.packageAddonsAmount)) {
        this.insuranceCost =
          Number(this.premiumAmount) + Number(this.packageAddonsAmount);
      } else {
        this.insuranceCost = 'XX,XX,XXX';
      }
      this.enableAddSummary = true;
    } else if (itemPlan.PACKAGEID == 0) {
      this.packageAddons = [];
      this.insuranceCost = 0;
      this.enableAddSummary = false;
    }
  }

  /**
   * On change of checkbox
   * @param event
   */
  onCheckChange(event) {
    const formArray: UntypedFormArray = this.insuranceForm.get(
      'chooseAddOnsId'
    ) as UntypedFormArray;

    /* Selected */
    if (event.target.checked) {
      // Add a new control in the arrayForm
      formArray.push(new UntypedFormControl(event.target.value));
    } else {
    /* unselected */
      // find the unselected element
      let i: number = 0;

      formArray.controls.forEach((ctrl: UntypedFormControl) => {
        if (ctrl.value == event.target.value) {
          // Remove the unselected element from the arrayForm
          formArray.removeAt(i);
          return;
        }
        i++;
      });
    }
  }

  /**
   * On click of checkbox of Zero Dep Addons
   * @param plan passing plan object
   */
  onSelectingZeroAddons(plan) {
    this.packageAddonsAmount = plan.ADDON_PREM_TOTAL;

    if (this.packageId.includes(plan.PACKAGEID)) {
      this.packageId = this.packageId.filter((id) => id != plan.PACKAGEID);
      this.packageNameArr = this.packageNameArr.filter(
        (name) => name != plan.PACKAGENAME
      );
      this.packageAddons = this.packageAddons.filter(
        (name) => name != plan.ADDONNAME
      );
    } else {
      this.packageId.push(plan.PACKAGEID);
      this.packageNameArr.push(plan.PACKAGENAME);
      this.packageAddons.push(plan.ADDONNAME);
    }

    if (this.premiumAmount && this.packageAddonsAmount) {
      this.insuranceCost =
        Number(this.premiumAmount) +
        Number(this.calculateTotalAddOnsAmount(this.packageId));
    } else {
      this.insuranceCost = 'XX,XX,XXX';
    }
    if (this.packageId.length < 1) {
      this.insuranceCost = 0;
      this.enableAddSummary = false;
    } else {
      this.enableAddSummary = true;
    }
  }

  calculateTotalAddOnsAmount(packageIdArr) {
    let totalAddOnsAmount = 0;
    this.chooseAddonsPlans.forEach((element) => {
      if (packageIdArr.includes(element.PACKAGEID))
        totalAddOnsAmount += Number(element.ADDON_PREM_TOTAL);
    });
    return totalAddOnsAmount;
  }

  async addToSummary() {
    // let insuranceDetails = {
    //   insuranceProvider: this.insuranceProvider,
    //   insuranceProviderCode: this.insuranceProviderCode,
    //   insurancePremium: this.premiumAmount,
    //   packageAddonsAmount:
    //     Number(this.insuranceCost) - Number(this.premiumAmount),
    //   insuranceCost: this.insuranceCost,
    //   stateId: this.stateId,
    //   stateName: this.stateList.find((el) => el.state_id == this.stateId)
    //     .state_name,
    //   cityId: this.cityId,
    //   cityName: this.cityList.find((el) => el.city_id == this.cityId).city_name,
    //   packageId: this.packageId,
    //   packageName: this.packageNameArr,
    //   AddonName: this.packageAddons,
    //   QuotationNo: this.quotationNumber,
    // };
    let insuranceDetails = {
      insuranceCost: this.insuranceCost,
      AddonName: this.packageAddons,
    };
    this.cachingService.setDataInSession(
      'insurancePlan_details',
      insuranceDetails
    );
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Click',
      'add insurance plan to summary'
    );
    this.apiService.sendReportingData({
      eName: 'click',
      eCat: 'insurance_clicked',
      eAct: 'add_insurance',
    });
    this.globalService.dismissModal('success');
  }

  async getInsuranceDetails() {
    let insuranceDetails = await this.cachingService.getDataFromSession(
      'insurancePlan_details'
    );
    if (insuranceDetails?.insuranceCost) {
      this.insuranceDetails = insuranceDetails;
      this.stateId = this.insuranceDetails.stateId;
      this.cityId = this.insuranceDetails.cityId;
      this.packageId = this.insuranceDetails.packageId;
      this.insuranceForm.setValue({
        state: this.insuranceDetails.stateId,
        city: this.insuranceDetails.cityId,
        packageId: this.insuranceDetails.packageId,
      });
      /**
       * Fetching City Data if Stored Data Available
       */
      let apiBody = {
        state_id: this.insuranceDetails.stateId.toString(),
      };
      this.apiService
        .post('insurance/get-cities', apiBody)
        .then(async (res) => {
          if (res['msg'] == 'success') {
            this.cityList = res['response']['cities'];
            let result = await this.onCitySelection(
              this.insuranceDetails.cityId.toString()
            );
            if (result) {
              this.onPackageSelection(this.packageId);
            }
          } else {
            console.error('City Fetch Error Values Error ');
          }
        })
        .catch((err) => {
          console.error('City Values: ', err);
        });

    } else {
      this.insuranceDetails = undefined;
    }
  }

  skipWarranty() {
    this.globalService.dismissModal();
    this.apiService.logGAEvent('uaevent', 'Content', 'Click', 'Skip insurance');
    this.apiService.sendReportingData({
      eName: 'click',
      eCat: 'insurance_clicked',
      eAct: 'skip_insurance',
    });
  }
}
